import React, { useEffect, useState } from 'react';
import { Input, Spin } from 'antd';
import { approvedOverviewTable } from '../../constants/cabinet';
import { postApi } from '../../redux/rest/restSlice';
import { APPROVED_CABINET } from '../../constants/actionTypes';
import { unwrapResult } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { TABLE_PAGINATION } from '../../utilities/helper';
import DataTable from '../DataTable';
import SummaryStrip from '../SummaryStrip';

const ApprovedCabinetOverviewTable = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [appliedSearch, setAppliedSearch] = useState('');

    const dispatch = useDispatch();

    const fetchApprovedCabinetList = (search = '') => {
        const term = (search || '').trim();

        setLoading(true);
        setAppliedSearch(term);
        dispatch(postApi({
            endpoint: APPROVED_CABINET,
            payload: {
                // Hardware ID search
                filters: term ? { cabinet_sn: term } : {},
            },
        }))
            .then(unwrapResult)
            .then((result) => {
                setLoading(false);
                setData(get(result, 'data'));
            })
            .catch(() => {
                setLoading(false);
            })
    };

    useEffect(() => {
        fetchApprovedCabinetList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const clearSearch = () => {
        setSearchValue('');
        fetchApprovedCabinetList('');
    };

    const rows = get(data, 'data') || [];
    const firstLoad = loading && !rows.length;
    const sum = (key) => rows.reduce((total, row) => total + (Number(row[key]) || 0), 0);

    const summary = rows.length
        ? [
            { label: 'Cabinets', value: rows.length },
            { label: 'Total slots', value: sum('total_slots') },
            { label: 'Battery packs present', value: sum('available_battery_pack'), tone: 'success' },
            { label: 'Empty slots', value: sum('free_slots'), tone: 'info' },
        ]
        : [];

    return (
        <Spin spinning={loading && !firstLoad}>
            <div className='list-toolbar'>
                <div className='list-toolbar__main'>
                    <Input.Search
                        className='list-toolbar__search'
                        placeholder='Search by Hardware ID'
                        allowClear
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onSearch={fetchApprovedCabinetList}
                    />
                </div>
            </div>

            {!firstLoad && <SummaryStrip items={summary} />}

            <DataTable
                skeleton={firstLoad}
                scrollX={600}
                rowKey='id'
                className='mt-20'
                dataSource={rows}
                columns={approvedOverviewTable()}
                pagination={TABLE_PAGINATION}
                emptyProps={{
                    noun: 'cabinets',
                    search: appliedSearch,
                    onClearSearch: clearSearch,
                }}
            />
        </Spin>
    );
};

export default ApprovedCabinetOverviewTable;
